import { CoverageIndicator, DataItemFormatter } from '@creditsights/styleguide-web';
import React, { ReactElement } from 'react';
import { isRpCovered } from '../../../../Company/Company.logic';

const CompanyCoverageRenderer: DataItemFormatter<string, ReactElement> = ({ item }) => {
  return (
    <CoverageIndicator
      csCoverage={item.csCoverage}
      lfiCoverage={item.lfiCoverage}
      crCoverage={item.crCoverage}
      financialsCoverage={item.financialsCoverage}
      riskProductsCoverage={isRpCovered({ riskProductsCoverage: item.riskProductsCoverage })}
    />
  );
};
export default CompanyCoverageRenderer;
